import {
  GROUH_MOSHTARI,
  GROUH_MOSHTARI_V2,
  SAVE_ALL_MOSHTARI_DATA,
  ALL_GROUH_MOSHTARI,
  ACTION_GET_MOSHTARI_RELATION,
  ACTION_GET_GROUP_MOSHTARI_RELATION,
  MOSHTARI_SEARCH,
} from "Stores/actionTypes";
import { updateObject } from "./utility";

const INIT_STATE = {
  customerData: [],
  customerDataPagination: { Limit: 10, Page: 1, Total: 0 },
  customerGroup: [],
  allGorohMoshtariData: [],
  dataRelationMoshtari: null,
  dataRelationGroupMoshtari: null,
  customerDataSearch: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ALL_MOSHTARI_DATA:
      return updateObject(state, {
        customerData: action.customerData,
        customerDataPagination: action.customerDataPagination,
      });
      case MOSHTARI_SEARCH:
        return updateObject(state, {
          customerDataSearch: action.customerDataSearch,
        });
    case GROUH_MOSHTARI:
      return updateObject(state, { customerGroup: action.customerGroup });
    case ALL_GROUH_MOSHTARI:
      return updateObject(state, {
        allGorohMoshtariData: action.allGorohMoshtariData,
      });
    case ACTION_GET_MOSHTARI_RELATION:
      return updateObject(state, {
        dataRelationMoshtari: action.dataRelationMoshtari,
      });
    case ACTION_GET_GROUP_MOSHTARI_RELATION:
      return updateObject(state, {
        dataRelationGroupMoshtari: action.dataRelationGroupMoshtari,
      });
    default:
      return state;
  }
};
